import { render, staticRenderFns } from "./BrowseDaichoEdited.vue?vue&type=template&id=2c2b67fd&scoped=true&"
import script from "./BrowseDaichoEdited.vue?vue&type=script&lang=js&"
export * from "./BrowseDaichoEdited.vue?vue&type=script&lang=js&"
import style0 from "./BrowseDaichoEdited.vue?vue&type=style&index=0&id=2c2b67fd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c2b67fd",
  null
  
)

export default component.exports